export default __webpack_public_path__ + "static/senehasa-9a83d6f24209a7aa1c93235099ec8ca9.png";